var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H8V8H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.969,8.084a.711.711,0,0,0,.695-.595,3.388,3.388,0,0,1,.993-1.884,3.615,3.615,0,0,1,1.886-.992.71.71,0,0,0,.6-.694.688.688,0,0,0-.794-.694,4.962,4.962,0,0,0-4.1,4.1A.7.7,0,0,0,3.969,8.084ZM2.645,2.6A7.924,7.924,0,0,0,.4,7.291a.724.724,0,0,0,.695.793.687.687,0,0,0,.695-.628A6.376,6.376,0,0,1,7.509,1.771a.687.687,0,0,0,.629-.694A.688.688,0,0,0,7.344.383,7.45,7.45,0,0,0,2.645,2.6Z",
    transform: "translate(-0.224 -0.213)",
    fill: "#9c0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealTimeIcon);
export default __webpack_public_path__ + "static/media/real-time-icon.4afdd86c4dd6160e8001b1e760458007.svg";
export { ForwardRef as ReactComponent };